import { render } from "./Services.vue?vue&type=template&id=957134a6&scoped=true"
import script from "./Services.vue?vue&type=script&lang=ts"
export * from "./Services.vue?vue&type=script&lang=ts"

import "./Services.vue?vue&type=style&index=0&id=957134a6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-957134a6"

export default script